"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrinkingWaterSource = void 0;
var DrinkingWaterSource;
(function (DrinkingWaterSource) {
    DrinkingWaterSource[DrinkingWaterSource["Classrooms"] = 1] = "Classrooms";
    DrinkingWaterSource[DrinkingWaterSource["Concession Stands"] = 2] = "Concession Stands";
    DrinkingWaterSource[DrinkingWaterSource["Faculty Lounge"] = 4] = "Faculty Lounge";
    DrinkingWaterSource[DrinkingWaterSource["Home Economics Room"] = 8] = "Home Economics Room";
    DrinkingWaterSource[DrinkingWaterSource["Ice Machines"] = 16] = "Ice Machines";
    DrinkingWaterSource[DrinkingWaterSource["Kitchen Sinks"] = 32] = "Kitchen Sinks";
    DrinkingWaterSource[DrinkingWaterSource["Nurses Station"] = 64] = "Nurses Station";
    DrinkingWaterSource[DrinkingWaterSource["Water Coolers"] = 128] = "Water Coolers";
    DrinkingWaterSource[DrinkingWaterSource["Athletic Facility"] = 256] = "Athletic Facility";
    DrinkingWaterSource[DrinkingWaterSource["Potable Filling Stations"] = 512] = "Potable Filling Stations";
})(DrinkingWaterSource = exports.DrinkingWaterSource || (exports.DrinkingWaterSource = {}));
//# sourceMappingURL=DrinkingWaterSource.js.map